// Action Types
export const SUBMIT_NUDGES_NEW_REQUEST = "SUBMIT_NUDGES_NEW_REQUEST";
export const SUBMIT_NUDGES_NEW_SUCCESS = "SUBMIT_NUDGES_NEW_SUCCESS";
export const SUBMIT_NUDGES_NEW_FAILURE = "SUBMIT_NUDGES_NEW_FAILURE";

// Action Creators
export const submitNudgesNewRequest = (formData) => {
  return (dispatch) => {
    dispatch({
      type: SUBMIT_NUDGES_NEW_REQUEST,
      payload: formData,
    });
  };
};

export const submitNudgesNewSuccess = (message) => ({
  type: SUBMIT_NUDGES_NEW_SUCCESS,
  payload: message,
});

export const submitNudgesNewFailure = (error) => ({
  type: SUBMIT_NUDGES_NEW_FAILURE,
  payload: error,
});